module.exports = __webpack_public_path__ + "fonts/arrow-up-right-from-square-regular.svg";